<template>
  <el-dialog title="导出列表" width="50%" :visible.sync="exportVisible" v-if="exportVisible" class="abow_dialog" append-to-body>
    <div class="export-list table-frame">
      <new-table ref="table" :data="tableData" :columns="columns" :pages="pages" :layout="layout"/>
    </div>
    <span slot="footer" class="dialog-footer" style="display: flex;justify-content: space-between">
      <span style="color: #FA5D5F;font-size: 14px">注：当前列表数据24小时内有效，请尽快下载</span>
      <div>
        <el-button @click="refreshList">刷新</el-button>
        <el-button @click="allClear">批量清空</el-button>
        <el-button @click="exportVisible = false">取 消</el-button>
      </div>
    </span>
  </el-dialog>
</template>

<script>
import newTable from "@/components/new-table"

export default {
  data() {
    return {
      layout: "prev, pager, next, total",
      exportVisible: false,
      tableData: [],
      columns: [
        {label: "菜单名称", prop: "menuName"},
        {
          label: "文件名称", prop: "fileName", render: (h, scope) => {
            return (<span>{scope.row.menuName + '.xls'}</span>)
          }
        },
        {label: "文件大小", prop: "fileSize",render:(h,scope)=>{
            return(
                <span>{scope.row.fileSize}k</span>
            )
          }},
        {label: "导出时间", prop: "creationTime"},

        {
          label: "是否完成",width:100, prop: "isCreate",
          render: (h, scope) => {
            return (<span>{scope.row.isCreate ? "是" : "否"}</span>)
          }
        },
        {
          label: "操作",
          render: (h, scope) => {
            return (
                <div>
                  <el-button type="text" style="margin-right: 10px" v-show={scope.row.isCreate} onClick={() => {
                    this.downFile(scope.row)
                  }}>下载
                  </el-button>
                  <el-button type="text" style="color: #FA5D5F;margin-left: 0" onClick={()=>this.delExport(scope.row)}>删除</el-button>
                </div>
            )
          }
        },
      ],
      pages: {
        props: {
          "page-size": 10,
          "current-page": 1,
          "total": 0
        },
        on: {
          "current-change": (p) => {
            this.pageChange(p);
          },
        },
      },
    }
  },
  methods: {
    open() {
      this.pages.props["current-page"] = 1;
      this.getList();
    },
    delExport(row){
      this.$confirm('确定要删除该条记录吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(`/Pay/FileExport/FileExport`,[`${ row.id }`]).then(() => {
          this.$message.success("删除成功");
          this.tableData.length == 1 && this.pages.props["current-page"] != 1 && (this.pages.props["current-page"] -= 1);
          this.getList();
        })
      })
    },
    downFile(params) {
      let url = this.$ossUrl + '/'+params.filePath;
      let fileName = params.menuName + '.xls'
      const xhr = new XMLHttpRequest();
      xhr.open('GET', url, true);
      xhr.responseType = 'blob';
      xhr.onload = () => {
        if (xhr.status === 200) {
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(xhr.response, fileName);
          } else {
            const link = document.createElement('a');
            const body = document.querySelector('body');
            link.href = window.URL.createObjectURL(xhr.response);
            link.download = fileName;
            // fix Firefox
            link.style.display = 'none';
            body.appendChild(link);
            link.click();
            body.removeChild(link);
            window.URL.revokeObjectURL(link.href);
          }
        }
      };
      xhr.send();
    },
    getList() {
      this.$axios.get(`/Pay/FileExport/FileExportList?pageIndex=${this.pages.props["current-page"]}&pageSize=${this.pages.props["page-size"]}&apiType=1`).then(res => {
        this.tableData = res.data;
        this.pages.props.total = res.dataCount;
        this.exportVisible = true;
      })
    },
    pageChange(p){
      this.pages.props["current-page"] = p;
      this.getList();
    },
    allClear() {
      this.$confirm('确定要清空列表吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(`/Pay/FileExport/AllFileExport`,{ apitype: 1 }).then(res=>{
          this.getList();
          this.$message.success("清空成功")
        })
      })
    },
    refreshList() {
      this.getList();
    },
  },
  components: { newTable }
}
</script>

<style lang="scss" scoped>
.export-list {
  ::v-deep .el-table__body-wrapper {
    height: 400px;
  }
}
</style>
